/**
 * OaSIS Explorer Frontend - Static Field Shorthand Mapping
 * 
 * Generated by: backend/scripts/generate-field-mapping-standalone.js
 * Generated on: 2026-03-14T19:32:03.940Z
 * Total fields: 252
 * 
 * DO NOT EDIT MANUALLY
 * Run `node backend/scripts/generate-field-mapping-standalone.js` to regenerate this file
 */

/**
 * Complete field shorthand mapping for all measurement fields
 * Generated deterministically to ensure consistency across environments
 */
export const FIELD_SHORTHAND_MAPPING = {
  /**
   * Forward mapping: full field name → shorthand code
   */
  fullToShorthand: {
    'accounting': 'accn',
    'activeLearning': 'al',
    'adaptability': 'adpt',
    'agricultureAndHorticulture': 'aah',
    'analyticalThinking': 'at',
    'analyzingDataOrInformation': 'adoi',
    'armHandSteadiness': 'ahs',
    'arts': 'arts',
    'assistingAndCaringForOthers': 'aacf',
    'attentionToDetail': 'atd',
    'auditoryAttention': 'aa',
    'automation': 'autm',
    'bendingOrTwistingTheBody': 'bott',
    'biologicalAgents': 'ba',
    'biology': 'bilg',
    'bodyFlexibility': 'bf',
    'buildingAndConstruction': 'bac',
    'businessAdministration': 'bau',
    'categorizationFlexibility': 'cf',
    'chemistry': 'chms',
    'clerical': 'clrc',
    'clericalActivities': 'ca',
    'clientServices': 'cs',
    'climbing': 'clmb',
    'coachingAndDevelopingOthers': 'cado',
    'collaboration': 'coll',
    'colourPerception': 'cp',
    'communicatingWithCoworkers': 'cwc',
    'communicatingWithPersonsOutsideOrganization': 'cwpo',
    'communicationsAndMedia': 'cam',
    'competition': 'comp',
    'computerTechnologyAndInformationSystems': 'ctai',
    'concernForOthers': 'cfo',
    'conflictSituations': 'cso',
    'consequenceOfError': 'coe',
    'contactWithOthersDuration': 'cwod',
    'contactWithOthersFrequency': 'cwof',
    'controlOfSettings': 'cos',
    'controllingMachinesAndProcesses': 'cmap',
    'coordinating': 'cord',
    'coordinatingOrLeadingOthers': 'colo',
    'coordinatingTheWorkAndActivitiesOfOthers': 'ctwa',
    'crampedWorkSpaceAwkwardPositions': 'cwsa',
    'creativity': 'crtv',
    'criticalThinking': 'ct',
    'dangerousChemicalSubstances': 'dcs',
    'dealWithExternalCustomers': 'dwec',
    'dealWithPhysicallyAggressivePeople': 'dwpa',
    'dealingWithUnpleasantOrAngryPeople': 'dwuo',
    'decisionMaking': 'dm',
    'deductiveReasoning': 'dr',
    'depthPerception': 'dp',
    'developingObjectivesAndStrategies': 'doas',
    'developingTechnicalInstructions': 'dti',
    'digitalLiteracy': 'dl',
    'digitalProduction': 'dpi',
    'dynamicStrength': 'ds',
    'economics': 'ecnm',
    'electricalAndElectronics': 'eae',
    'electronicMail': 'em',
    'electronicMaintenance': 'eml',
    'equipmentAndToolSelection': 'eats',
    'establishingAndMaintainingInterpersonalRelationships': 'eami',
    'estimateQuantifiableCharacteristics': 'eqc',
    'evaluatingInformationToDetermineComplianceWithStandards': 'eitd',
    'evaluation': 'evlt',
    'explosiveStrength': 'es',
    'extremeTemperatures': 'et',
    'extremelyBrightOrInadequateLighting': 'eboi',
    'faceToFaceDiscussions': 'ftfd',
    'farVision': 'fv',
    'finance': 'finn',
    'fingerDexterity': 'fd',
    'fingerHandWristMotion': 'fhwm',
    'fluencyOfIdeas': 'foi',
    'forestry': 'fors',
    'formPerception': 'fp',
    'freedomToMakeDecisions': 'ftmd',
    'frequencyOfDecisionMaking': 'fodm',
    'generalLearningAbility': 'gla',
    'geologicalResources': 'gr',
    'geoscience': 'gesc',
    'gettingInformation': 'gi',
    'glareTolerance': 'gt',
    'grossBodyCoordination': 'gbc',
    'grossBodyEquilibrium': 'gbe',
    'handEyeCoordination': 'hec',
    'handlingAndMovingObjects': 'hamo',
    'handlingMaterialManually': 'hmm',
    'hazardousConditions': 'hc',
    'hazardousEquipmentMachineryTools': 'hemt',
    'hearingSensitivity': 'hs',
    'highPlaces': 'hp',
    'hollandCode1': 'hco',
    'hollandCode2': 'hcl',
    'hollandCode3': 'hca',
    'hollandCodesAny': 'hcao',
    'hospitality': 'hosp',
    'humanResourcesAndLabourRelations': 'hral',
    'humanities': 'humn',
    'identifyingObjectsActionsAndEvents': 'ioaa',
    'impactOfDecisions': 'iod',
    'inAnEnclosedVehicleOrEquipmentDuration': 'iaev',
    'inAnEnclosedVehicleOrEquipmentFrequency': 'iaevn',
    'inAnOpenVehicleOrEquipmentDuration': 'iaov',
    'inAnOpenVehicleOrEquipmentFrequency': 'iaovn',
    'independence': 'indp',
    'indoorsEnvironmentallyControlledDuration': 'iecd',
    'indoorsEnvironmentallyControlledFrequency': 'iecf',
    'indoorsNotEnvironmentallyControlledDuration': 'inec',
    'indoorsNotEnvironmentallyControlledFrequency': 'inecn',
    'inductiveReasoning': 'ir',
    'informationOrdering': 'io',
    'innovativeness': 'innv',
    'inspectingEquipmentStructuresOrMaterial': 'ieso',
    'instructing': 'inst',
    'interactingWithComputers': 'iwc',
    'interpretingTheMeaningOfInformationForOthers': 'itmo',
    'judgingQuality': 'jq',
    'keepingOrRegainingBalance': 'korb',
    'languages': 'lang',
    'law': 'law',
    'leadership': 'ledr',
    'learningAndTeachingStrategies': 'lats',
    'libraryConservationAndHeritage': 'lcah',
    'livestockFarmAnimalsAndWildlife': 'lfaa',
    'logistics': 'logs',
    'makingDecisions': 'md',
    'makingRepetitiveMotions': 'mrm',
    'managementOfFinancialResources': 'mofr',
    'managementOfMaterialResources': 'momr',
    'managementOfPersonnelResources': 'mopr',
    'managingResources': 'mr',
    'manualDexterity': 'mda',
    'manufacturingProcessingAndProduction': 'mpap',
    'mathematicalReasoning': 'mra',
    'mathematics': 'math',
    'mechanicalMaintenance': 'mm',
    'mechanicsAndMachinery': 'mam',
    'memorizing': 'memr',
    'mentalHealth': 'mh',
    'monitoring': 'mont',
    'monitoringProcessesMaterialsOrSurroundings': 'mpmo',
    'multiLimbCoordination': 'mlc',
    'multiSignalResponse': 'msr',
    'multitasking': 'mult',
    'nearVision': 'nv',
    'negotiating': 'negt',
    'nightVision': 'nvi',
    'numeracy': 'numr',
    'numericalAbility': 'na',
    'operatingVehiclesMechanizedDevicesOrEquipment': 'ovmd',
    'operationAndControl': 'oac',
    'operationMonitoringOfMachineryAndEquipment': 'omom',
    'oralCommunicationActiveListening': 'ocal',
    'oralCommunicationOralComprehension': 'ococ',
    'oralCommunicationOralExpression': 'ocoe',
    'outsideExposedToWeatherDuration': 'oetw',
    'outsideExposedToWeatherFrequency': 'oetwu',
    'outsideUnderCoverDuration': 'oucd',
    'outsideUnderCoverFrequency': 'oucf',
    'paceDeterminedBySpeedOfEquipment': 'pdbs',
    'patternIdentification': 'pi',
    'patternOrganizationSpeed': 'pos',
    'perceptualSpeed': 'ps',
    'performanceMeasurement': 'pm',
    'performingForOrWorkingDirectlyWithThePublic': 'pfow',
    'performingGeneralPhysicalActivities': 'pgpa',
    'peripheralVision': 'pv',
    'persuading': 'pers',
    'physicalHealth': 'ph',
    'physicalProximity': 'pp',
    'physics': 'phys',
    'planningAndOrganizing': 'pao',
    'precision': 'prcs',
    'preventativeMaintenance': 'pmr',
    'problemIdentification': 'pir',
    'problemSolving': 'psr',
    'processingInformation': 'pio',
    'productDesign': 'pd',
    'providingConsultationAndAdvice': 'pcaa',
    'publicAffairsAndGovernmentRelations': 'paag',
    'publicSafetyAndSecurity': 'psas',
    'publicSpeaking': 'psu',
    'qualityControlTesting': 'qct',
    'radiation': 'radt',
    'rateControl': 'rc',
    'reactionTime': 'rt',
    'readingComprehension': 'rce',
    'recreationLeisureAndFitness': 'rlaf',
    'repairing': 'repr',
    'resolvingConflictsAndNegotiatingWithOthers': 'rcan',
    'responsibilityForOutcomesAndResultsOfOtherWorkers': 'rfoa',
    'responsibleForOthersHealthAndSafety': 'rfoh',
    'saleAndMarketing': 'sam',
    'schedulingWorkAndActivities': 'swaa',
    'selectiveAttention': 'sa',
    'sellingOrInfluencingOthers': 'soio',
    'serviceOrientation': 'so',
    'settingUp': 'su',
    'sitting': 'sitt',
    'skinInjury': 'si',
    'socialOrientation': 'soo',
    'socialPerceptiveness': 'sp',
    'soundAndNoiseDuration': 'sand',
    'soundAndNoiseFrequency': 'sanf',
    'soundLocalization': 'sl',
    'spatialOrientation': 'sop',
    'spatialVisualization': 'sv',
    'specializedSafetyEquipment': 'sse',
    'speechClarity': 'sc',
    'speechRecognition': 'sr',
    'speedOfLimbMovement': 'solm',
    'staffing': 'stff',
    'stamina': 'stmn',
    'standardSafetyEquipment': 'sset',
    'standing': 'stnd',
    'staticStrength': 'ss',
    'stressTolerance': 'st',
    'structuredVersusUnstructuredWork': 'svuw',
    'supervisingSubordinates': 'ssu',
    'systemsAnalysis': 'say',
    'tasksRepetition': 'tr',
    'teaching': 'tech',
    'teamBuilding': 'tb',
    'technicalDesign': 'td',
    'telecommunications': 'telc',
    'telephone': 'telp',
    'theologyAndPhilosophy': 'tap',
    'thinkingCreatively': 'tc',
    'timeManagement': 'tm',
    'timePressureFrequency': 'tpf',
    'timePressureImportance': 'tpi',
    'trainingAndTeaching': 'tat',
    'trainingMentoringAndCoaching': 'tmac',
    'troubleshooting': 'trbl',
    'trunkStrength': 'ts',
    'usingNewRelevantKnowledge': 'unrk',
    'vehiclesAndMachineryOperations': 'vamo',
    'verbalAbility': 'va',
    'veterinarianAndAnimalCare': 'vaac',
    'vibration': 'vibr',
    'walkingAndRunning': 'war',
    'waterResources': 'wr',
    'workSchedule': 'ws',
    'workWeekDuration': 'wwd',
    'workWithWorkGroupOrTeamFrequency': 'wwwg',
    'workWithWorkGroupOrTeamImportance': 'wwwgo',
    'writing': 'wrtn',
    'writtenCommunications': 'wc',
    'writtenComprehension': 'wcr',
    'writtenExpression': 'we',
  },

  /**
   * Reverse mapping: shorthand code → full field name
   */
  shorthandToFull: {
    'accn': 'accounting',
    'al': 'activeLearning',
    'adpt': 'adaptability',
    'aah': 'agricultureAndHorticulture',
    'at': 'analyticalThinking',
    'adoi': 'analyzingDataOrInformation',
    'ahs': 'armHandSteadiness',
    'arts': 'arts',
    'aacf': 'assistingAndCaringForOthers',
    'atd': 'attentionToDetail',
    'aa': 'auditoryAttention',
    'autm': 'automation',
    'bott': 'bendingOrTwistingTheBody',
    'ba': 'biologicalAgents',
    'bilg': 'biology',
    'bf': 'bodyFlexibility',
    'bac': 'buildingAndConstruction',
    'bau': 'businessAdministration',
    'cf': 'categorizationFlexibility',
    'chms': 'chemistry',
    'clrc': 'clerical',
    'ca': 'clericalActivities',
    'cs': 'clientServices',
    'clmb': 'climbing',
    'cado': 'coachingAndDevelopingOthers',
    'coll': 'collaboration',
    'cp': 'colourPerception',
    'cwc': 'communicatingWithCoworkers',
    'cwpo': 'communicatingWithPersonsOutsideOrganization',
    'cam': 'communicationsAndMedia',
    'comp': 'competition',
    'ctai': 'computerTechnologyAndInformationSystems',
    'cfo': 'concernForOthers',
    'cso': 'conflictSituations',
    'coe': 'consequenceOfError',
    'cwod': 'contactWithOthersDuration',
    'cwof': 'contactWithOthersFrequency',
    'cos': 'controlOfSettings',
    'cmap': 'controllingMachinesAndProcesses',
    'cord': 'coordinating',
    'colo': 'coordinatingOrLeadingOthers',
    'ctwa': 'coordinatingTheWorkAndActivitiesOfOthers',
    'cwsa': 'crampedWorkSpaceAwkwardPositions',
    'crtv': 'creativity',
    'ct': 'criticalThinking',
    'dcs': 'dangerousChemicalSubstances',
    'dwec': 'dealWithExternalCustomers',
    'dwpa': 'dealWithPhysicallyAggressivePeople',
    'dwuo': 'dealingWithUnpleasantOrAngryPeople',
    'dm': 'decisionMaking',
    'dr': 'deductiveReasoning',
    'dp': 'depthPerception',
    'doas': 'developingObjectivesAndStrategies',
    'dti': 'developingTechnicalInstructions',
    'dl': 'digitalLiteracy',
    'dpi': 'digitalProduction',
    'ds': 'dynamicStrength',
    'ecnm': 'economics',
    'eae': 'electricalAndElectronics',
    'em': 'electronicMail',
    'eml': 'electronicMaintenance',
    'eats': 'equipmentAndToolSelection',
    'eami': 'establishingAndMaintainingInterpersonalRelationships',
    'eqc': 'estimateQuantifiableCharacteristics',
    'eitd': 'evaluatingInformationToDetermineComplianceWithStandards',
    'evlt': 'evaluation',
    'es': 'explosiveStrength',
    'et': 'extremeTemperatures',
    'eboi': 'extremelyBrightOrInadequateLighting',
    'ftfd': 'faceToFaceDiscussions',
    'fv': 'farVision',
    'finn': 'finance',
    'fd': 'fingerDexterity',
    'fhwm': 'fingerHandWristMotion',
    'foi': 'fluencyOfIdeas',
    'fors': 'forestry',
    'fp': 'formPerception',
    'ftmd': 'freedomToMakeDecisions',
    'fodm': 'frequencyOfDecisionMaking',
    'gla': 'generalLearningAbility',
    'gr': 'geologicalResources',
    'gesc': 'geoscience',
    'gi': 'gettingInformation',
    'gt': 'glareTolerance',
    'gbc': 'grossBodyCoordination',
    'gbe': 'grossBodyEquilibrium',
    'hec': 'handEyeCoordination',
    'hamo': 'handlingAndMovingObjects',
    'hmm': 'handlingMaterialManually',
    'hc': 'hazardousConditions',
    'hemt': 'hazardousEquipmentMachineryTools',
    'hs': 'hearingSensitivity',
    'hp': 'highPlaces',
    'hco': 'hollandCode1',
    'hcl': 'hollandCode2',
    'hca': 'hollandCode3',
    'hcao': 'hollandCodesAny',
    'hosp': 'hospitality',
    'hral': 'humanResourcesAndLabourRelations',
    'humn': 'humanities',
    'ioaa': 'identifyingObjectsActionsAndEvents',
    'iod': 'impactOfDecisions',
    'iaev': 'inAnEnclosedVehicleOrEquipmentDuration',
    'iaevn': 'inAnEnclosedVehicleOrEquipmentFrequency',
    'iaov': 'inAnOpenVehicleOrEquipmentDuration',
    'iaovn': 'inAnOpenVehicleOrEquipmentFrequency',
    'indp': 'independence',
    'iecd': 'indoorsEnvironmentallyControlledDuration',
    'iecf': 'indoorsEnvironmentallyControlledFrequency',
    'inec': 'indoorsNotEnvironmentallyControlledDuration',
    'inecn': 'indoorsNotEnvironmentallyControlledFrequency',
    'ir': 'inductiveReasoning',
    'io': 'informationOrdering',
    'innv': 'innovativeness',
    'ieso': 'inspectingEquipmentStructuresOrMaterial',
    'inst': 'instructing',
    'iwc': 'interactingWithComputers',
    'itmo': 'interpretingTheMeaningOfInformationForOthers',
    'jq': 'judgingQuality',
    'korb': 'keepingOrRegainingBalance',
    'lang': 'languages',
    'law': 'law',
    'ledr': 'leadership',
    'lats': 'learningAndTeachingStrategies',
    'lcah': 'libraryConservationAndHeritage',
    'lfaa': 'livestockFarmAnimalsAndWildlife',
    'logs': 'logistics',
    'md': 'makingDecisions',
    'mrm': 'makingRepetitiveMotions',
    'mofr': 'managementOfFinancialResources',
    'momr': 'managementOfMaterialResources',
    'mopr': 'managementOfPersonnelResources',
    'mr': 'managingResources',
    'mda': 'manualDexterity',
    'mpap': 'manufacturingProcessingAndProduction',
    'mra': 'mathematicalReasoning',
    'math': 'mathematics',
    'mm': 'mechanicalMaintenance',
    'mam': 'mechanicsAndMachinery',
    'memr': 'memorizing',
    'mh': 'mentalHealth',
    'mont': 'monitoring',
    'mpmo': 'monitoringProcessesMaterialsOrSurroundings',
    'mlc': 'multiLimbCoordination',
    'msr': 'multiSignalResponse',
    'mult': 'multitasking',
    'nv': 'nearVision',
    'negt': 'negotiating',
    'nvi': 'nightVision',
    'numr': 'numeracy',
    'na': 'numericalAbility',
    'ovmd': 'operatingVehiclesMechanizedDevicesOrEquipment',
    'oac': 'operationAndControl',
    'omom': 'operationMonitoringOfMachineryAndEquipment',
    'ocal': 'oralCommunicationActiveListening',
    'ococ': 'oralCommunicationOralComprehension',
    'ocoe': 'oralCommunicationOralExpression',
    'oetw': 'outsideExposedToWeatherDuration',
    'oetwu': 'outsideExposedToWeatherFrequency',
    'oucd': 'outsideUnderCoverDuration',
    'oucf': 'outsideUnderCoverFrequency',
    'pdbs': 'paceDeterminedBySpeedOfEquipment',
    'pi': 'patternIdentification',
    'pos': 'patternOrganizationSpeed',
    'ps': 'perceptualSpeed',
    'pm': 'performanceMeasurement',
    'pfow': 'performingForOrWorkingDirectlyWithThePublic',
    'pgpa': 'performingGeneralPhysicalActivities',
    'pv': 'peripheralVision',
    'pers': 'persuading',
    'ph': 'physicalHealth',
    'pp': 'physicalProximity',
    'phys': 'physics',
    'pao': 'planningAndOrganizing',
    'prcs': 'precision',
    'pmr': 'preventativeMaintenance',
    'pir': 'problemIdentification',
    'psr': 'problemSolving',
    'pio': 'processingInformation',
    'pd': 'productDesign',
    'pcaa': 'providingConsultationAndAdvice',
    'paag': 'publicAffairsAndGovernmentRelations',
    'psas': 'publicSafetyAndSecurity',
    'psu': 'publicSpeaking',
    'qct': 'qualityControlTesting',
    'radt': 'radiation',
    'rc': 'rateControl',
    'rt': 'reactionTime',
    'rce': 'readingComprehension',
    'rlaf': 'recreationLeisureAndFitness',
    'repr': 'repairing',
    'rcan': 'resolvingConflictsAndNegotiatingWithOthers',
    'rfoa': 'responsibilityForOutcomesAndResultsOfOtherWorkers',
    'rfoh': 'responsibleForOthersHealthAndSafety',
    'sam': 'saleAndMarketing',
    'swaa': 'schedulingWorkAndActivities',
    'sa': 'selectiveAttention',
    'soio': 'sellingOrInfluencingOthers',
    'so': 'serviceOrientation',
    'su': 'settingUp',
    'sitt': 'sitting',
    'si': 'skinInjury',
    'soo': 'socialOrientation',
    'sp': 'socialPerceptiveness',
    'sand': 'soundAndNoiseDuration',
    'sanf': 'soundAndNoiseFrequency',
    'sl': 'soundLocalization',
    'sop': 'spatialOrientation',
    'sv': 'spatialVisualization',
    'sse': 'specializedSafetyEquipment',
    'sc': 'speechClarity',
    'sr': 'speechRecognition',
    'solm': 'speedOfLimbMovement',
    'stff': 'staffing',
    'stmn': 'stamina',
    'sset': 'standardSafetyEquipment',
    'stnd': 'standing',
    'ss': 'staticStrength',
    'st': 'stressTolerance',
    'svuw': 'structuredVersusUnstructuredWork',
    'ssu': 'supervisingSubordinates',
    'say': 'systemsAnalysis',
    'tr': 'tasksRepetition',
    'tech': 'teaching',
    'tb': 'teamBuilding',
    'td': 'technicalDesign',
    'telc': 'telecommunications',
    'telp': 'telephone',
    'tap': 'theologyAndPhilosophy',
    'tc': 'thinkingCreatively',
    'tm': 'timeManagement',
    'tpf': 'timePressureFrequency',
    'tpi': 'timePressureImportance',
    'tat': 'trainingAndTeaching',
    'tmac': 'trainingMentoringAndCoaching',
    'trbl': 'troubleshooting',
    'ts': 'trunkStrength',
    'unrk': 'usingNewRelevantKnowledge',
    'vamo': 'vehiclesAndMachineryOperations',
    'va': 'verbalAbility',
    'vaac': 'veterinarianAndAnimalCare',
    'vibr': 'vibration',
    'war': 'walkingAndRunning',
    'wr': 'waterResources',
    'ws': 'workSchedule',
    'wwd': 'workWeekDuration',
    'wwwg': 'workWithWorkGroupOrTeamFrequency',
    'wwwgo': 'workWithWorkGroupOrTeamImportance',
    'wrtn': 'writing',
    'wc': 'writtenCommunications',
    'wcr': 'writtenComprehension',
    'we': 'writtenExpression',
  }
} as const;

/**
 * Get shorthand code for a field name
 */
export function getFieldShorthand(fieldName: string): string | null {
  return FIELD_SHORTHAND_MAPPING.fullToShorthand[fieldName as keyof typeof FIELD_SHORTHAND_MAPPING.fullToShorthand] || null;
}

/**
 * Get full field name for a shorthand code
 */
export function getFieldFullName(shorthand: string): string | null {
  return FIELD_SHORTHAND_MAPPING.shorthandToFull[shorthand as keyof typeof FIELD_SHORTHAND_MAPPING.shorthandToFull] || null;
}

/**
 * Check if a string is a valid shorthand code
 */
export function isFieldShorthand(code: string): boolean {
  return code in FIELD_SHORTHAND_MAPPING.shorthandToFull;
}

/**
 * Check if a string is a valid full field name
 */
export function isFieldFullName(name: string): boolean {
  return name in FIELD_SHORTHAND_MAPPING.fullToShorthand;
}

/**
 * Get all field name → shorthand mappings
 */
export function getAllFieldShorthands(): Record<string, string> {
  return { ...FIELD_SHORTHAND_MAPPING.fullToShorthand };
}

/**
 * Get all shorthand → field name mappings
 */
export function getAllShorthandFields(): Record<string, string> {
  return { ...FIELD_SHORTHAND_MAPPING.shorthandToFull };
}
